import React from "react";
import { CIERRE, BRAND, IMAGES, FOOTER } from "@/content";
import WhatsAppButton from "@/components/WhatsAppButton";
import Reveal from "@/components/Reveal";

export function Cierre() {
  return (
    <section
      className="relative overflow-hidden py-16 md:py-24"
      style={{ background: "linear-gradient(180deg, #6B1F3A 0%, #4A1428 100%)" }}
      data-testid="section-cierre"
    >
      <div
        className="blob"
        style={{
          width: 320,
          height: 320,
          top: -60,
          right: -100,
          background: "rgba(139,197,63,0.16)",
        }}
      />
      <div className="container-page relative z-[1]">
        <div className="mx-auto text-center" style={{ maxWidth: 620 }}>
          <Reveal>
            <img
              src={IMAGES.asesor}
              alt={`${BRAND.asesor}, distribuidor independiente FuXion`}
              loading="lazy"
              className="mx-auto rounded-full object-cover"
              style={{
                width: 140,
                height: 140,
                border: "4px solid rgba(255,255,255,0.9)",
                boxShadow: "0 18px 40px rgba(0,0,0,0.3)",
              }}
            />
          </Reveal>

          <Reveal delay={80}>
            <h2 className="h2-display text-white mt-7">{CIERRE.h2}</h2>
          </Reveal>

          {CIERRE.parrafos.map((p, i) => (
            <Reveal key={i} delay={160 + i * 80}>
              <p
                className="mt-5 text-[17px] leading-relaxed"
                style={{ color: "rgba(255,255,255,0.86)" }}
              >
                {p}
              </p>
            </Reveal>
          ))}

          <Reveal delay={320} className="mt-9">
            <WhatsAppButton section="cierre" size="lg" full className="sm:w-auto" />
          </Reveal>

          <Reveal delay={400}>
            <p
              className="mt-7 text-[22px]"
              style={{
                fontFamily: "'Caveat', cursive",
                color: "var(--lima)",
                lineHeight: 1.3,
              }}
            >
              {CIERRE.firma(BRAND.asesor, BRAND.ciudad)}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer
      className="pt-10 pb-24 md:pb-10"
      style={{
        background: "var(--vino-dark)",
        borderTop: "1px solid rgba(255,255,255,0.12)",
      }}
      data-testid="footer"
    >
      <div className="container-page">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center gap-5">
            <img
              src={BRAND.logoNutradeyBlanco}
              alt="Nutradey"
              className="h-9 w-auto opacity-95"
              loading="lazy"
            />
            <span
              style={{
                width: 1,
                height: 26,
                background: "rgba(255,255,255,0.2)",
                display: "block",
              }}
            />
            <img
              src={BRAND.isotipoFuxionBlanco}
              alt="FuXion"
              className="h-7 w-auto opacity-80"
              loading="lazy"
            />
          </div>

          <p
            className="text-[12px] leading-relaxed text-center max-w-[860px]"
            style={{ color: "rgba(255,255,255,0.62)" }}
          >
            {FOOTER.legal}
          </p>
          <p
            className="text-[12px] leading-relaxed text-center max-w-[760px]"
            style={{ color: "rgba(255,255,255,0.62)" }}
          >
            {FOOTER.disclaimer}
          </p>
          <p
            className="text-[12px] pt-3"
            style={{
              color: "rgba(255,255,255,0.5)",
              borderTop: "1px solid rgba(255,255,255,0.12)",
              width: "100%",
              textAlign: "center",
            }}
          >
            {FOOTER.copy}
          </p>
        </div>
      </div>
    </footer>
  );
}
